import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'app-supplier-discount-select',
    // exportAs: 'ngModel', disabled until finding out how to replace #project="ngModel" attribute of <app-project-select> to render validation errors via <span *ngIf="project.invalid && (project.dirty || project.touched)">
    templateUrl: './supplier-discount-select.component.html',
    styleUrls: ['./supplier-discount-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SupplierDiscountSelectComponent),
            multi: true
        }
    ]
})
export class SupplierDiscountSelectComponent implements ControlValueAccessor {
    @Input() items: any[] = [];
    @Input() disabled = false;
    @Output() discountChange = new EventEmitter<any>();

    value: any;

    private onChange: (val: any) => void = () => {};
    private onTouched: () => void = () => {};

    onChanged(event: any) {
        this.value = event;
        this.onChange(event);
        this.onTouched();
        this.discountChange.emit(event);
    }

    writeValue(val: any): void { this.value = val; }
    registerOnChange(fn: any): void { this.onChange = fn; }
    registerOnTouched(fn: any): void { this.onTouched = fn; }
    setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }
}